import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconZap: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="zap, lightning, flash, thunder"><path d="M14 1.75005C14 1.42403 13.7894 1.13535 13.4789 1.03584C13.1685 0.936333 12.8293 1.04879 12.6397 1.31407L3.13974 14.6114C2.97642 14.84 2.95456 15.1407 3.08311 15.3905C3.21166 15.6403 3.46905 15.7973 3.75 15.7973H10V22.2501C10 22.5771 10.2119 22.8664 10.5236 22.9651C10.8354 23.0638 11.1752 22.9491 11.3634 22.6817L20.8634 9.18167C21.0245 8.95269 21.0447 8.65303 20.9157 8.40452C20.7867 8.15601 20.53 8.00005 20.25 8.00005H14V1.75005Z" fill="currentColor"/></CentralIconBase>;
};

export default IconZap;
